import * as React from 'react';

const EmailConfirm = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={72} height={72} fill="none" viewBox="0 0 72 72" {...props}>
        <g
            stroke="#393939"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            clipPath="url(#emailconfirm_a)"
        >
            <path d="m58.5 26.25 12 8.25V66a4.5 4.5 0 0 1-4.5 4.5H6A4.5 4.5 0 0 1 1.5 66V34.5l12-8.25" />
            <path d="m10.5 61.5 15-12h21l15 12M70.5 34.5l-18 12M1.5 34.5l18 12M58.5 42.501V4.5a3 3 0 0 0-3-3h-39a3 3 0 0 0-3 3v38.001" />
            <path d="M47 21.812a11.16 11.16 0 0 1-11 11.19 10.837 10.837 0 0 1-11-10.809 11.16 11.16 0 0 1 11-11.192 10.84 10.84 0 0 1 11 10.811M34 25h4.5" />
            <path d="M36.501 25v-6.5a.5.5 0 0 0-.812-.39l-1.688 1.35" />
        </g>
        <defs>
            <clipPath id="emailconfirm_a">
                <path fill="#fff" d="M0 0h72v72H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default EmailConfirm;
